import React from 'react';
import advocateProfilePic from '../../../assets/images/advocates-details/HaripriyaIppili.jpg';

const AdvocateHariPriyaIDetails = () => {
  return (
    <section className='team-details'>
      <div className='container'>
        <div className='row justify-content-between'>
          <div className='col-lg-5'>
            <div className='team-details__content'>
              <h2 className='team-details__title'>Read my story</h2>
              <p className='team-details__text'>
                Ms. Hari Priya Ippili has completed her LL.B from Padala Rama Reddy Law College, Hyderabad and she has completed her 
                Post Graduation Diploma in Modern Corporate Law from Osmania University. Currently she is pursuing her LL.M from Osmania University. 
                She also holds a Master’s degree in Psychology. Further strengthening her professional skills she has obtained 
                a Certificate in Mediation from Bangalore International Mediation, Arbitration and Conciliation Centre (BIMACC)
                 in collaboration with ICFAI Law School, Hyderabad. Ms. Haripriya enrolled as an Advocate in the year 2025. 
                 She is currently practicing in High Court for the State of Telangana and also in various Civil & Criminal Courts
             in Hyderabad.
              </p>
            </div>
          </div>
          <div className='col-lg-6'>
            <div className='team-one__single'>
              <div className='team-one__image' style={{ textAlign: 'center' }}>
                <img
                  src={advocateProfilePic}
                  alt='K Hari Priya Ippili'
                  style={{
                    objectFit: 'cover',
                    objectPosition: 'center center',
                    display: 'block',
                    margin: '0 auto',
                    maxWidth: '100%',
                    height: 'auto',
                    border: 'none',
                    outline: 'none',
                    boxShadow: 'none'
                  }}
                />
              </div>
              <div className='team-one__content'>
                <h2 className='team-one__name'>
                  Ms. Hari Priya Ippili. BB.A, LL.B, PGDMCL, M.A (Psychology), LL.M,
                </h2>
                <p className='team-one__designation'>Advocate</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AdvocateHariPriyaIDetails;

